<template>
   <div>
    <div>
        <div class="clearfix table-tools">
        <div class="search" style="width:100%;">
            <a-form layout='inline' @submit="searchList">
            <a-form-item v-if="false">
                <a-radio-group :value="paramsData.search.shsz">
                    <a-radio-button value="sh" @click="handleButChange('sh')">
                    主板
                    </a-radio-button>
                    <a-radio-button value="sz" @click="handleButChange('sz')">
                    创业
                    </a-radio-button>
                </a-radio-group>
            </a-form-item>

            <a-form-item v-if="false">
                <a-radio-group :value="paramsData.search.line_type">
                    <a-radio-button value="" @click="handleLineButChange('')">
                    全部
                    </a-radio-button>
                    <a-radio-button value="1" @click="handleLineButChange('1')">
                    主线
                    </a-radio-button>
                </a-radio-group>
            </a-form-item>

            <a-form-item v-if="false">
                <a-radio-group :value="paramsData.search.sz_type">
                    <a-radio-button value="" @click="handleSzButChange('')">
                    全部
                    </a-radio-button>
                    <a-radio-button value="small" @click="handleSzButChange('small')">
                    小盘
                    </a-radio-button>
                    <a-radio-button value="tiny" @click="handleSzButChange('tiny')">
                    超小
                    </a-radio-button>
                </a-radio-group>
            </a-form-item>

            <a-form-item v-if="false">
                <a-tooltip placement="topLeft">
                    <template slot="title">
                    <span>股票代码</span>
                    </template>
                    <a-input v-model.trim="paramsData.search.stock_code" allowClear placeholder="股票代码" style="width: 180px"/>
                </a-tooltip>
            </a-form-item>
            <a-form-item>
                <a-tooltip placement="topLeft" >
                <template slot="title">
                    <span>时间筛选</span>
                </template>
                <a-range-picker
                    :ranges="rangesData"
                    :value='rangesValue'
                    :disabled-date="disabledDate" :allowClear="false"
                    :default-value="[moment(paramsData.search.start_date,'YYYY-MM-DD'),moment(paramsData.search.end_date,'YYYY-MM-DD')]"  style="width: 240px"
                    @change="(date, dateString)=>onChange(date, dateString,1)" />
                </a-tooltip>
            </a-form-item>

            <a-form-item v-if="false">
                <a-tooltip placement="topLeft" >
                <a-select v-model.trim="paramsData.search.stock_reason" style="width: 120px">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option :value="item.bk_name" v-for="(item, index) in main_list" :key="index">{{item.bk_name}}</a-select-option>
                </a-select>
                </a-tooltip>
            </a-form-item>

            <!-- <a-form-item>
                <a-tooltip placement="topLeft">
                    <a-input v-model.trim="paramsData.search.limit" allowClear style="width: 180px"/>
                </a-tooltip>
            </a-form-item> -->

            <a-form-item>
                <a-tooltip placement="topLeft">
                    <a-input v-model.trim="paramsData.search.b_trigger_type" allowClear style="width: 180px"/>
                </a-tooltip>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" html-type="submit" @click="searchList">搜索「{{bili_total}}/{{stk_count}}」</a-button>
            </a-form-item>
            <a-form-item>
                <a-button type="default" @click="previewAllCharts">Preview</a-button>
            </a-form-item>
            <!-- <a-form-item style="float: right;" :v-if="showOpt">
                <a-button type="danger" icon="heart" @click="clk_sold">Sold</a-button>
            </a-form-item> -->

            </a-form>
            <!-- <hr/> -->

            <!-- <a-tag @click="con_clk('')">昨日全部</a-tag> -->
            <!-- <a-tag v-for="(item,index) in yesterday_kick_resason_list" @click="con_clk(item.stock_reason)">{{item.stock_reason}} # {{item.total}}</a-tag> -->


            <!-- <a-tag v-for="(item,index) in concept_short_list">{{item.concept_is}} # {{item.concept_count}}</a-tag> -->
        
            <!-- <hr/> -->

            <!--concept_is_ary-->
            <!-- <a-tag color="blue" @click="clkConceptIsAry('')">全部</a-tag> -->
            <!-- <a-tag v-for="(item,index) in concept_is_ary_list" :key="'concept_is_ary_'+index" color="orange" @click="clkConceptIsAry(item.concept_is_ary)">{{item.concept_is_ary}}</a-tag> -->

            <!-- <a-tag v-for="(item,index) in main_list" :key="index" color="red" @click="clkzt(item.bk_name)">{{item.bk_name}} # {{(formatNumber(item.kick_count))}}</a-tag> -->
            <hr/>

            <!-- <a-tag v-for="(item,index) in kick_resason_list" :key="'kick_resason_'+index" :color="item.color" @click="clkConceptIsAry(item.stock_reason)">{{item.stock_reason}} # {{item.total}}</a-tag> -->
            <!-- <hr/> -->

            <!-- <a-tag @click="con_clk('')">今日全部</a-tag> -->
            <!-- <a-tag v-for="(item,index) in kick_resason_list" :color="item.color" @click="con_clk(item.stock_reason)">{{item.stock_reason}} # {{item.total}}/{{item.cyb}}</a-tag> -->


            <!-- <hr/> -->

            <!-- <a-tag v-for="(item,index) in sort_kick_resason_list" :color="item.color" @click="con_clk(item.stock_reason)">{{item.stock_reason}} # {{item.tm}} # {{item.total}}</a-tag> -->

            <!-- <hr/>
            9:25 <a-tag v-for="(item,index) in bk_list" @click="con_clk(item.bk_name)">{{item.bk_name}} # {{item.bk_avgp}}</a-tag>
            <hr/>
            9:35 <a-tag v-for="(item,index) in bk_two_list" @click="con_clk(item.bk_name)">{{item.bk_name}} # {{item.bk_avgp}}</a-tag> -->

        </div>
        </div>
        <div class="table">
        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>

        <div class="table-container">
            <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
                :columns="columns" :dataSource="filtered_list" @change="handleChange" :scroll="{ x: 'max-content' }">
            <template slot="index" slot-scope="text, record , index">
            <span>{{(index+1)}}</span>
            </template>
            <template #bodyCell="{ text }">
                <div class="cell-content">
                    {{ text }}
                </div>
            </template>
            <template slot="stock_zhangting_shijian" slot-scope="text, record , index">
                <span @click="clktime(record.c,record)">{{text}}</span>
            </template>

            <template slot="concept_name" slot-scope="text, record , index">
                <span @click="viewConcept(record)">{{text}}</span>
                <a-badge :count="record.concept_kick_count"></a-badge>
            </template>

            <template slot="concept_is" slot-scope="text, record , index">
                <span @click="viewConcept(record)">{{text}}</span>
            </template>

            <template slot="bullish" slot-scope="text, record , index">
                <span :style="{ color: 'red' }">{{ (formatNumber(text)) }}</span>
            </template>

            <template slot="bearish" slot-scope="text, record , index">
                <span :style="{ color: 'green' }">{{ (formatNumber(text)) }}</span>
            </template>

            <template slot="stock_yb" slot-scope="text, record , index">
                <a-popover :title="text">
                    <template slot="content">
                        <div style="text-align: center;">
                            <!-- <img :src="record.cdl_url" alt="" widssth="900px" :key="record._cdlKey || record.cdl_url"> -->
                            <img :src="record.chart_url" alt="" width="450px" :key="record._chartKey || record.chart_url">
                        </div>
                        <div style="text-align: center;">
                            <!-- <a-button @click="refreshCdlChart(record)" size="small" style="margin-bottom: 10px;">强制刷新</a-button> -->
                            <a-button @click="refreshChart(record)" size="small" style="margin-bottom: 10px;">强制刷新</a-button>
                        </div>
                    </template>
                    <span :style="{ color: (record.is_red || record.b_trigger) ? 'red' : record.is_green ? '#FAB12F':'' }"> {{ (text) }}</span>
                    
                </a-popover>
                <!-- <span :style="{ color: record.is_red ? 'red' : record.is_green ? 'yellow':'' }" @click="clk_buy(record.c,record.n)"> {{ (text) }}</span> -->
                <!-- <span :style="{ color: record.is_red ? 'red' : '' }"> {{ (text) }}</span> -->
            </template>

            <template slot="rank" slot-scope="text, record , index">
                <span @click="viewRank(record)">{{text}}</span>
            </template>

            <template slot="R3" slot-scope="text, record , index">
                <span @click="viewR(record)">{{text}}</span>
            </template>

            <template slot="stock_date" slot-scope="text, record , index">
                <!-- <span :style="{ color: record.pred_label=='1' ? 'red' :'' }">{{text}}</span> 
                <a-popover :title="record.n">
                    <template slot="content">
                        <div style="text-align: center;">
                            <img :src="record.cdl_url" alt="" width="900px" :key="record._cdlKey || record.cdl_url">
                        </div>
                        <div style="text-align: center;">
                            <a-button @click="refreshCdlChart(record)" size="small" style="margin-bottom: 10px;">强制刷新</a-button>
                        </div>
                    </template>
                    <span :style="{ color: record.pred_label=='1' ? 'red' :'' }">{{text}}</span>
                </a-popover>
                -->
                <span :style="{ color: record.pred_label=='1' ? 'red' :'' }">{{text}}</span>
            </template>
            
            <template slot="stock_name" slot-scope="text, record , index">
                <div class="cell-content">
                    {{ text }}
                </div>
                <!-- <a-tag color="orange" v-for="(tagname,index) in record.tags.T">
                    {{tagname}}
                </a-tag>
                <a-tag color="green" v-for="(tagname,index) in record.tags.S">
                    {{tagname}}
                </a-tag>
                <a-tag color="red" v-for="(tagname,index) in record.tags.B">
                    {{tagname}}
                </a-tag> -->
            </template>

            <template slot="stock_code" slot-scope="text, record , index">
                <!-- <span @click="clk(record.c,record)">{{text}}</span> -->
                <!-- <span @click.stop v-clipboard:copy="record.c">{{text}}</span> -->
                <span @click.stop v-clipboard:copy="record.c" :style="{ color: record.stock_is_hit =='1' ? 'red' : '' }">{{text}}</span>
            </template>
            <template slot="stock_bk_name" slot-scope="text, record , index">
                <span @click="clkzt(text)">{{text}}</span><a href="#" style="color:red;">({{record.stock_bk_zhangtingshu}})</a>
            </template>
            <template slot="price" slot-scope="text, record , index">
                <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
            </template>

            <template slot="fs_one_s" slot-scope="text, record , index">
                <span :style="{color:record.fs_one_sec>0? 'red' : 'green'}"> {{ (formatNumber(record.fs_one.S)) }}</span>
            </template>

            <template slot="fs_one" slot-scope="text, record , index">
                <span :style="{color:record.fs_one_sec>0? 'red' : 'green'}"> {{ (formatNumber(record.fs_one.B)) }}</span>
            </template>

            <template slot="fs_one_total" slot-scope="text, record , index">
                <span :style="{ color: record.fs_one_total.stock_is_low =='0' ? 'red' : '' }"> {{ ((text.bili)) }}</span>
            </template>

            <template slot="one_opt" slot-scope="text, record , index">
                <span v-if="record.one_opt['1']" :style="{ color: record.one_opt['1'].fs_type =='B' ? 'red' : 'green' }">{{ (formatNumber(record.one_opt['1'].fs_total)) }}/{{record.one_opt['1'].sp}}</span>
                <!-- <span v-for="(item,index) in record.one_opt" > {{ ((item.fs_type)) }}</span> -->
            </template>

            <template slot="fs_one_total_m" slot-scope="text, record , index">
                <span> {{ (formatNumber(text.stock_gap_total)) }}</span>
            </template>

            <template slot="opt" slot-scope="text, record , index">
                <span :style="{ color: record.fs_one_sec > 0 ? 'red' : 'green' }">{{ (formatNumber(record.fs_one_sec)) }}</span>
            </template>

            <template slot="yb" slot-scope="text, record , index">
                <span :style="{ color: text > 1 ? 'red' : '' }"> {{ (formatNumber(text)) }}</span>
            </template>

            <template slot="stock_zongzhi" slot-scope="text, record , index">
                <span :style="{ color: text > 1e10 ? 'red' : 'green' }"> {{ (formatNumber(text)) }}</span>
            </template>

            <template slot="stock_reminder_msg" slot-scope="text, record , index">
                <div style="white-space: pre-wrap;" @click="clk(record.stock_code)">{{text}}</div>
            </template>

            <template slot="stock_signal" slot-scope="text, record , index">
                <span v-if="text">{{text.stock_signal}}/{{text.confidence}}</span>
            </template>

            <template slot="macd" slot-scope="text, record , index">
                <span @click="copyShapeToClipboard(record)">{{text}}</span>
            </template>

            <template slot="stock_shap_rank" slot-scope="text, record , index">
                <span :class="getRankClass(text)">{{ text }}</span>
            </template>

            <template slot="pregnant_line" slot-scope="text, record , index">
                <span v-if="getPregnantLineSignal(record)" :style="{color: getPregnantLineSignal(record).color}">
                    {{getPregnantLineSignal(record).text}}
                </span>
            </template>
            
            <template slot="action" slot-scope="text, record , index">
                <!-- <a-button v-if="(showOpt && hasPreviewed) || record.b_trigger" :disabled="bili_total < 800" @click="clk_swi(record.c, record.n)" type="primary" size="small">Go</a-button> -->
                <a-button :disabled="bili_total < 800" @click="clk_swi(record.c, record.n)" type="primary" size="small">Go</a-button>
            </template>
        </a-table>
        </div>
        </div>
        <!-- <div class="page">
            <a-pagination
            :pageSizeOptions="pageSizeOptions"
            :total="pageParams.totalCount"
            showSizeChanger
            :pageSize="pageParams.perPage"
            v-model="current"
            @change="changePage"
            @showSizeChange="onShowSizeChange"
            :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
            >
                <template slot='buildOptionText' slot-scope='props'>
                <span v-if="props.value!=='100'">{{props.value}}条/页</span>
                <span v-if="props.value==='100'">100条/页</span>
                </template>
            </a-pagination>
        </div> -->
    </div>
    <!-- <editModal v-if="editVisible" :item="modalData"/> -->
    <a-modal v-model="editVisible" :title="stock_title" cancelText="取消" okText="刷新" width="1550px" @ok="handleOk" >
        <vue-element-loading :active="loadingP" color="#00cca2" spinner="spinner"/>
        <!-- <a-date-picker @change="onFsChange" /> -->
         <ve-candle :data="{
          columns: ['日期', '开', '收', '低', '高', '量'],
          rows: day_line
        }" :settings="chartStockSettings" :title="{
                          left: '100',     // 水平位置自动调整
                          bottom: '-10',      // 底部居中
                          textBaseline: 'middle', // 文本垂直居中对齐
                          textAlign: 'center',   // 文本水平居中对齐
                          textStyle: {
                              fontSize: 9.5,
                          }
            }" judge-width/>
        <ve-histogram 
            v-if="false"
            :data="predictLiuruChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`资金流入统计 - `+(formatNumber(kick_amount)),
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['M'],
                axisSite: { right: ['M'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

        <LRanking v-if="false" title="分价表" :rank_data="rankPrice"/>

        <ve-histogram 
        v-if="false"
        :data="orderBookChart" 
        :legend="{show:true,bottom:10}"
        judge-width
        :grid="{right: '5%'}"
        :mark-line="markLine"
        :title="{
            text:`买卖委托统计 - `+(formatNumber(kick_amount)),
            textStyle: {
                fontSize: 15,
            },
            subtextStyle: {
                fontSize: 12.5
            }
        }"
        :settings="{
            label: { show: false, position: 'top'},
            yAxisType: ['KMB', 'KMB'], 
            showLine: ['M'],
            axisSite: { right: ['M'] }, 
        }" 
        :extend="histogramChartExtend" ></ve-histogram>

        <ve-histogram 
            v-if="false"
            :data="fs_list_chart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`${fs_list_chart.title}`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['P','A'],
                axisSite: { right: ['P','A'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>
        <a-row :gutter="[16,8]">
            <a-col :span="2"  v-for="(data,index) in pie" :key="index" @click="clkFs(data)">
                    <ve-pie  
                        judge-width
                        :data="data"
                        :legend="{
                            show:false,
                            type:'scroll',
                            orient: 'vertical',
                            left:'0%',
                            align:'left',
                            top:'middle',
                            textStyle: {
                                color:'#8C8C8C'
                            },
                        }
                        "
                        height="90px" 
                        :title="{
                            text:`${data.title}`,
                            x:'center',
                            y:'bottom',
                            textStyle: {
                                fontSize: 12.5,
                            },
                            subtextStyle: {
                                fontSize: 12.5
                            },
                        }" 
                        :extend="{
                            series:{
                                labelLine: {
                                    show: false, //隐藏指示线
                                },
                                label: {
                                    show: false, //隐藏标示文字
                                },
                                radius: data.radius,
                                center: ['50%', '35%'],
                            }
                        }">
                    </ve-pie>
                </a-col>
            </a-row>
            <ve-histogram 
            v-if="false"
            :data="predictChart" 
            :legend="{show:true,bottom:10}"
            judge-width
            :grid="{right: '5%'}"
            :mark-line="markLine"
            :title="{
                text:`${predictChart.title}`,
                textStyle: {
                    fontSize: 15,
                },
                subtextStyle: {
                    fontSize: 12.5
                }
            }"
            :settings="{
                label: { show: false, position: 'top'},
                yAxisType: ['KMB', 'KMB'], 
                showLine: ['超大','流入','大','成交','类型','涨','占比',],
                axisSite: { right: ['涨'] }, 
            }" 
            :extend="histogramChartExtend" ></ve-histogram>

            <a-card v-for="(tableData, index) in kick_his_list" :key="index" v-if="false">
                <a-table size="small" :pagination="false" :bordered='false' rowKey="id"
                    :columns="ztcolumns" :dataSource="tableData">
                    <template slot="index" slot-scope="text, record , index">
                    <span>{{(index+1)}}</span>
                    </template>
                    <template slot="price" slot-scope="text, record , index">
                    <span :style="color(text)"> {{ (formatNumber(text)) }}</span>
                    </template>
                </a-table>
            </a-card>

            <template>
            <!-- <a-timeline>
                <a-timeline-item :color="msg.color" v-for="(msg,index) in predictMsg" :key="index">{{msg.stock_date}} {{msg.tm}} {{msg.msg}}</a-timeline-item>
            </a-timeline> -->
        </template>
        <LEmpty v-if="first>0 && predictChart.rows.length == 0"/>
    </a-modal>

    <a-modal v-model="previewVisible" width="1800px" :footer="null">
        <template slot="title">
            <span>所有图表预览</span>
            <a-button type="primary" size="small" @click="refreshAllCharts" style="margin-left: 20px;">刷新全部</a-button>
        </template>
        <div style="max-height: 80vh; overflow-y: auto;">
            <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 15px;">
                <div v-for="(record, index) in filtered_list" :key="index" style="border: 1px solid #e8e8e8; padding: 15px; border-radius: 8px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                        <h4 style="margin: 0; font-size: 14px;">{{ record.n }} ({{ record.c }})</h4>
                        <a-button size="small" @click="refreshChart(record)">刷新</a-button>
                    </div>
                    <div style="text-align: center;">
                        <img :src="record.chart_url" alt="" width="100%" :key="record._chartKey || record.chart_url" style="max-width: 400px; cursor: pointer;" @click="enlargeChart(record)">
                    </div>
                    <div style="text-align: center; margin-top: 5px; font-size: 12px; color: #888;">
                        {{ record.stock_date }}
                    </div>
                </div>
            </div>
        </div>
    </a-modal>

    <a-modal v-model="enlargeVisible" :title="enlargeRecord ? enlargeRecord.n + ' (' + enlargeRecord.c + ')' : ''" cancelText="关闭" width="1400px" :footer="null">
        <div style="text-align: center;">
            <img :src="enlargeRecord ? enlargeRecord.chart_url : ''" alt="" width="100%" :key="enlargeRecord ? enlargeRecord._chartKey || enlargeRecord.chart_url : ''" style="max-width: 1300px;">
        </div>
        <div style="text-align: center; margin-top: 10px;">
            <a-button @click="refreshChart(enlargeRecord)" size="small">刷新</a-button>
        </div>
    </a-modal>

    <a-drawer
      :title="stock_detail.stock_name"
      placement="left"
      @close="onClose"
      :closable="false"
      :visible="drvisible"
    >
    <a-list size="small" bordered :data-source="stock_detail.stock_concept_list">
        <a-list-item slot="renderItem" slot-scope="item, index" @click="clk_concept(item.concept_code,item)">
            {{ item.concept_name }} # {{ item.concept_rate }} # {{ item.kick_count }}
        </a-list-item>
    </a-list>
    </a-drawer>

    <a-modal v-model="fsVisible" cancelText="取消" okText="刷新" width="1550px">
        <a-row :gutter="[16,16]">
            <a-col :span="4"  v-for="(data,index) in fs_list" :key="index">
                <a-timeline>
                    <a-timeline-item :color="msg.color" v-for="(msg,index) in data" :key="index">{{msg.stock_time}} # {{msg.fs_opt}} # {{formatNumber(msg.fs_total)}} </a-timeline-item>
                </a-timeline>
            </a-col>
        </a-row>
    </a-modal>

  </div>
</template>

<script>

const ztcolumns = [
  { title: '#', width:'70px', scopedSlots: { customRender: 'index' }, key: 'id' ,sorter:()=>{}},
  { title: '涨停时间',  align:'left', dataIndex: 'stock_zhangting_shijian', key: 'stock_zhangting_shijian',sorter:()=>{}, scopedSlots: { customRender: 'stock_zhangting_shijian' }},
  { title: '股票名称',  align:'left', dataIndex: 'stock_name', key: 'stock_name',sorter:()=>{}},
  { title: '连板',  align:'left', dataIndex: 'kick_no', key: 'kick_no',sorter:()=>{}},
  { title: '股票代码',  align:'left', dataIndex: 'stock_code', key: 'stock_code',sorter:()=>{}, scopedSlots: { customRender: 'stock_code' }},
  { title: '主力封单',  align:'left', dataIndex: 'stock_fengdan', key: 'stock_fengdan',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '最大封单',  align:'left', dataIndex: 'stock_max_fengdan', key: 'stock_max_fengdan',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力净额',  align:'left', dataIndex: 'stock_zhuli_jinge', key: 'stock_zhuli_jinge',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力卖出',  align:'left', dataIndex: 'stock_zhuli_maichu', key: 'stock_zhuli_maichu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '主力买入',  align:'left', dataIndex: 'stock_zhuli_mairu', key: 'stock_zhuli_mairu',sorter:()=>{}, scopedSlots: { customRender: 'price' }},
  { title: '股票板块', width: 160, align:'left', dataIndex: 'stock_bk', key: 'stock_bk',sorter:()=>{}},
  { title: '涨停原因', width: 160, align:'left', dataIndex: 'stock_reason', key: 'stock_reason',sorter:()=>{}, scopedSlots: { customRender: 'stock_bk_name' }},
] 

const columns = [
  { title: '#', width:'50px', scopedSlots: { customRender: 'index' }, key: 'id'},
//   { title: '股票日期',  align:'left', dataIndex: 'stock_date', key: 'stock_date',sorter:()=>{}},
  { title: '时间',  align:'left', dataIndex: 'stock_date', key: 'stock_date',scopedSlots: { customRender: 'stock_date' }},
  { title: '代码',  align:'left', dataIndex: 'c', key: 'c', scopedSlots: { customRender: 'stock_code' }},
  { title: '名称',  align:'left', dataIndex: 'n', key: 'n', scopedSlots: { customRender: 'stock_yb' }},
  //{ title: '操作', align: 'left', scopedSlots: { customRender: 'action' }, key: 'action' },
  { title: 'CR',  align:'left', dataIndex: 'cross_up', key: 'cross_up'},
  { title: 'TP',  align:'left', dataIndex: 'b_trigger_type', key: 'b_trigger_type'},
  { title: 'TK',  align:'left', dataIndex: 'tk_pct', key: 'tk_pct'},
//   { title: 'MA',  align:'left', dataIndex: 'macd', key: 'macd', scopedSlots: { customRender: 'macd' }},
  { title: 'bk', align:'left', dataIndex: 'concept_is', key: 'concept_is'},
  { title: '昨收',  align:'left', dataIndex: 'yesterday_zhangdiefu', key: 'yesterday_zhangdiefu', scopedSlots: { customRender: 'price' }},
  { title: '昨换',  align:'left', dataIndex: 'yesterday_huanshou', key: 'yesterday_huanshou' },
  { title: '昨流',  align:'left', dataIndex: 'yesterday_liuru', key: 'yesterday_liuru', scopedSlots: { customRender: 'price' },sorter:()=>{}},
//  { title: '935',  align:'left', dataIndex: '935_liuru', key: '935_liuru', scopedSlots: { customRender: 'price' },sorter:()=>{}},
  { title: 'GK',  align:'left', dataIndex: 'stock_gap_kaipan', key: 'stock_gap_kaipan'},
  { title: '开',  align:'left', dataIndex: 'stock_kaipan', key: 'stock_kaipan', scopedSlots: { customRender: 'price' }},
  { title: '新',  align:'left', dataIndex: 'stock_zhangdiefu', key: 'stock_zhangdiefu', scopedSlots: { customRender: 'price' }},
  { title: 'ZG',  align:'left', dataIndex: 'stock_zhangdiefu_gap', key: 'stock_zhangdiefu_gap', scopedSlots: { customRender: 'price' }},
  { title: '930', align:'left', dataIndex: 'stock_930', key: 'stock_930' , scopedSlots: { customRender: 'price' }},
  { title: '930比', align:'left', dataIndex: 'stock_930_liangbi', key: 'stock_930_liangbi'},
//  { title: '935比', align:'left', dataIndex: '935_liangbi', key: '935_liangbi'},
//   { title: '今比', align:'left', dataIndex: 'stock_liangbi', key: 'stock_liangbi'},
//   { title: '昨比', align:'left', dataIndex: 'yes_liangbi', key: 'yes_liangbi'},
//   { title: '五比', align:'left', dataIndex: 'yesterday_liangbi', key: 'yesterday_liangbi'},
  { title: 'ONE',align:'left', dataIndex: 'one_bili', key: 'one_bili'},
  { title: 'TWO',align:'left', dataIndex: 'two_bili', key: 'two_bili'},
  { title: 'TB',align:'left', dataIndex: 'two_total_bili', key: 'two_total_bili'},
  { title: 'TOTAL',align:'left', dataIndex: 'two_total', key: 'two_total',scopedSlots: { customRender: 'price' }},
  { title: '市值',  align:'left', dataIndex: 'stock_zongzhi', key: 'stock_zongzhi', scopedSlots: { customRender: 'price' }},
  { title:'931',  align:'left', dataIndex: 'stock_precent', key: 'stock_precent', scopedSlots: { customRender: 'price' }},
  { title:'932',  align:'left', dataIndex: 'two_stock_precent', key: 'two_stock_precent', scopedSlots: { customRender: 'price' }},
  { title:'1GP',  align:'left', dataIndex: 'stock_gap_precent', key: 'stock_gap_precent', scopedSlots: { customRender: 'price' }},
  { title:'2GP',  align:'left', dataIndex: 'two_stock_gap_precent', key: 'two_stock_gap_precent', scopedSlots: { customRender: 'price' }},
//  { title:'YRI',  align:'left', dataIndex: 'yes_rsi', key: 'yes_rsi'},
//   { title:'Y2',  align:'left', dataIndex: 'rsi6_avg2', key: 'rsi6_avg2'},
//  { title:'YC',  align:'center', dataIndex: 'yes_rsi_cha', key: 'yes_rsi_cha'},
//  { title:'MC',  align:'center', dataIndex: 'yes_macd_cha', key: 'yes_macd_cha'},
//   { title:'YGP',  align:'center', dataIndex: 'yesterday_gap_precent', key: 'yesterday_gap_precent'},
] 

import editModal from './editModal'
import ranges from "@/common/mixins/ranges"
import moment from 'moment'
import tableMixins from '@/common/mixins/table'
export default {
    name:'biliGrid',
    mixins: [ tableMixins , ranges],
    data() {
        this.chartSettings = {
        xAxisType: ['KMB', 'percent'],
      }
      this.markLine = {
          symbol: ['none', 'none'], //去掉箭头
          data: [],
          label:{
              show: false, //隐藏标示文字
              position:'insideStartTop'
          }
      },
      this.tooltip = {
          show:true,  
          trigger: "axis",
          alwaysShowContent:true,
          formatter: function(params) { 
            var res;
            console.log(params)
            return res;
          }
        },
      this.chartStockSettings = {
        yAxis:{
          show:false,
        },
        grid: {
          containLabel: true,
        },
        showDataZoom: false,
        start: 0,
        end: 100,
        showMA: false,
        MA: [5,10],
        legendName: {}, 
        showVol: false,
        upColor: '#FF8787',
        downColor: '#7FB77E',
      }
      this.markLine = {
          symbol: ['none', 'none'], //去掉箭头
          data: [],
          label:{
              show: false, //隐藏标示文字
              position:'insideEndTop'
          }
      },
      this.toolbox = {
          feature: {
          magicType: {},
          saveAsImage: {pixelRatio:2}
          }
      }
        return {
            first:0,
            dlLoading:false,
            loading: false,
            fsVisible:false,
            kickLoading:false,
            kickVisible:false,
            dVisible: false,
            drvisible:false,
            start_date:'',
            kick_amount:0,
            zt_name:'',
            bili_total:0,
            stk_count:0,
            concept:{},
            record:{},
            fs_list:[],
            rankPrice:[],
            detail_list:[],
            liuruChart:[],
            liuruList:[],
            fs_list_chart:{},
            kick_list:[],
            yesterday_kick_resason_list:[],
            kick_resason_list:[],
            concept_short_list:[],
            main_list:[],
            concept_is_ary_list:[],
            filtered_list:[],
            sort_kick_resason_list:[],
            kick_his_list:[],
            bk_list:[],
            bk_two_list:[],
            end_date:'',
            stock_title:'',
            columns,
            paramsData:{
                "page": 1,
                "per-page": 10,
                "search": {
                    shsz:'',
                    sz_type:'sz',
                    line_type:'',
                    yrsi6:'',
                    stock_reason:'',
                    stock_tm:'931',
                    ver:'',
                    limit:25,
                    b_trigger_type:'',
                    pred_model:'rf_none_cal',
                    concept_is_ary:'',
                },
                "sort": '',
                filter_type:'day',
                start_date:'',
                end_date:'',
            },
            pageParams: {
                currentPage: 1,
                pageCount: 50,
                perPage: 10,
                totalCount: 0,
            },
            searchData: {
                shsz:'sz',
                keyword:'',
                bk_date:'',
                bk_sort:'2',
                bk_mode:'kick'
            },
            modalData:{},
            editVisible : false,
            previewVisible: false,
            enlargeVisible: false,
            enlargeRecord: null,
            list:[],
            appList:[],
            histogramChartExtend:{
            series(item){
                console.log(item)
                    if(item){
                        item[0].barMaxWidth = 10;
                        item[0].color = '#23d9ae';
                        if(item[1]){
                            item[1].barMaxWidth = 10;
                            item[1].color='red'
                        }
                        if(item[3]){
                            item[3].barMaxWidth = 10;
                            item[3].color='#FF6600'
                        }
                    }
                    return item
                },
                xAxis:{
                    axisLine:{
                        show:true,
                        lineStyle: {
                            type: 'dotted',
                        }
                    },
                },
                yAxis(item){
                    item[0].axisLine = Object.assign({}, {
                        show:false
                    })
                    item[0].splitLine = Object.assign({}, {
                        show:true,
                        lineStyle: {
                            type: 'dotted'
                        }
                    })
                    return item
                },
            },
            pie:{},
            showOpt:false,
            showPriorityAlert: true,
            hasPreviewed: false,
            stockCode:'',
            predictMsg:[],
            day_line:[],
            anaysis:[],
            stock_detail:{},
            stockChartData:[],
            dailyChart:[],
            predictChart:[],
            orderBookChart:[],
            predictLiuruChart:[],
            loadingP:false,
            liuruChart:[],
            liuruList:[],
        }
    },
    components: {
        editModal,
    },
    created () {
        this.paramsData.search.start_date = moment().subtract('days',0).format('YYYY-MM-DD')
        this.paramsData.search.end_date = moment().subtract('days',0).format('YYYY-MM-DD')
        this.paramsData.start_date = this.paramsData.search.start_date
        this.paramsData.end_date = this.paramsData.search.end_date
        this.rangesValue = [moment(this.paramsData.search.start_date,'YYYY-MM-DD'),moment(this.paramsData.search.end_date,'YYYY-MM-DD')]
        if(this.$ls.get('employee_id')=='42476' || this.$ls.get('employee_id')=='100071'){
            this.showOpt = true
        }
    },
    methods: {
        previewAllCharts() {
            this.hasPreviewed = true;
            this.previewVisible = true;
        },
        refreshAllCharts() {
            this.filtered_list.forEach(record => {
                this.refreshChart(record);
            });
        },
        enlargeChart(record) {
            this.enlargeRecord = record;
            this.enlargeVisible = true;
        },
        refreshChart(record) {
            // 生成带force_refresh参数的新URL
            let baseUrl = record.chart_url.split('?')[0];
            let params = record.chart_url.split('?')[1] || '';
            
            // 移除已存在的force_refresh参数
            if (params) {
                params = params.replace(/&?force_refresh=\d*/g, '').replace(/^&/, '');
            }
            
            // 添加新的force_refresh参数，使用时间戳确保每次刷新都是唯一的
            let separator = params ? '&' : '?';
            let timestamp = Date.now();
            record.chart_url = baseUrl + (params ? '?' + params : '') + separator + 'force_refresh=' + timestamp;
            
            // 使用key强制重新渲染图片
            this.$set(record, '_chartKey', timestamp);
        },
        refreshCdlChart(record) {
            // 生成带force_refresh参数的新URL
            let baseUrl = record.cdl_url.split('?')[0];
            let params = record.cdl_url.split('?')[1] || '';
            
            // 移除已存在的force_refresh参数
            if (params) {
                params = params.replace(/&?force_refresh=\d*/g, '').replace(/^&/, '');
            }
            
            // 添加新的force_refresh参数
            let separator = params ? '&' : '?';
            record.cdl_url = baseUrl + (params ? '?' + params : '') + separator + 'force_refresh=1';
            
            // 使用key强制重新渲染图片
            this.$set(record, '_cdlKey', Date.now());
        },
        async viewHis(record){
            let href= 'https://test.wedots.cn/v2b/labs/stock/ds?stock_code='+record.c+'&stock_date='+record.stock_date;
            window.open(href, '_blank')
        },
        async viewRank(record){
            let href= 'https://vipmoney.eastmoney.com/collect/stockranking/pages/ranking9_3/stock.html?code='+record.c+'&market=0';
            // console.log(href)
            window.open(href, '_blank')
        },
        async clk_swi(stock_code,stock_name){
            let that = this;
            this.$confirm({
                title: 'Are you sure '+stock_name+'?',
                content: '',
                okText: 'Yes',
                okType: 'danger',
                cancelText: 'No',
                onOk() {
                    that.loading = true
                    let res = that.$store.dispatch('enterpriseLabStockSwiAction', {data:{stock_code:stock_code}})
                    that.loading = false
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
            //console.log(stock_code);
        },
        async clk_sold(){
            let that = this;
            this.$confirm({
                title: 'Are you sure?',
                content: '',
                okText: 'Yes',
                okType: 'danger',
                cancelText: 'No',
                async onOk() {
                    that.loading = true
                    try {
                        let res = await that.$store.dispatch('enterpriseLabStockSoldAction', {data:{}})
                        if(res && res.code === 200) {
                            that.$message.success('操作成功');
                        }
                    } catch (error) {
                        console.error('Error in clk_sold:', error);
                    } finally {
                        that.loading = false
                    }
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        async clk_buy(stock_code,stock_name){
            let that = this;
            this.$confirm({
                title: 'Are you sure '+stock_name+'?',
                content: '',
                okText: 'Yes',
                okType: 'danger',
                cancelText: 'No',
                onOk() {
                    that.loading = true
                    let res = that.$store.dispatch('enterpriseLabStockMbuyAction', {data:{stock_code:stock_code}})
                    that.loading = false
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
            //console.log(stock_code);
        },
        async viewR(record){
            let href= 'https://test.wedots.cn/v2b/labs/stock/process?stock_code='+record.c
            // console.log(href)
            window.open(href, '_blank')
        },
        async con_clk(con_name){
            this.loading = true
            this.paramsData.search.con_name = con_name
            this.paramsData.search.start_date = this.paramsData.start_date
            this.paramsData.search.end_date = this.paramsData.end_date
            let res = await this.$store.dispatch('enterpriseLabStockTimesAction', {data:this.paramsData})
            this.list = res.items
            this.kick_resason_list = res.kick_list
            this.sort_kick_resason_list = res.sort_kick_list
            this.yesterday_kick_resason_list = res.yesterday_kick_list
            this.bk_list = res.bk_list
            this.bk_two_list = res.bk_two_list
            this.loading = false
        },
        disabledDate(current) {
             // 注意：current 是当前遍历到的日期，类型为Day.js对象
            const day = current.day(); // 获取星期几，0为周日，6为周六
            return day === 0 || day === 6;
        },
        onClose(){
            this.drvisible = false;
        },
        async addStock(record){
            console.log(record)
            // let bk_name = this.concept?this.concept.concept_name:this.record.stock_reason;
            // let res = await this.$store.dispatch('enterpriseLabStockAddStockAction', { data: {search:{stock_code:record.stock_code,bk_name:bk_name}} })
            // this.$message.success('添加成功');
        },
        async clk_concept(concept_code,item){
            this.record = item
            this.concept=item;
            this.drvisible=false;
            this.dVisible = true;
            this.dlLoading = true;
            let obj = {}
            let { searchData } = this
            if (searchData) {
                for (let k in searchData) {
                    obj[k] = searchData[k]
                }
            }
            obj['start_date'] = this.paramsData.start_date
            obj['end_date'] = this.paramsData.end_date
            this.searchParams.search = obj
            this.searchParams.code = concept_code
            let _seach = this.searchParams;
            _seach.sort='stock_zhangdiefu';
            let res = await this.$store.dispatch('enterpriseLabStockBkDetailAction', { data: _seach })
            this.detail_list = [];
            this.detail_list = res.data.list
            this.liuruChart = res.data.liuru_chart
            this.dlLoading = false;
        },
        async getDetail(record,keyword,add) {
            this.dVisible = true;
            this.record = record;
            this.dlLoading = true;
            let obj = {}
            let { searchData } = this
            if (searchData) {
                for (let k in searchData) {
                    obj[k] = searchData[k]
                }
            }
            obj['start_date'] = this.paramsData.start_date
            obj['end_date'] = this.paramsData.end_date

            if(add){
                obj['add'] = add;
            }  
            this.searchParams.search = obj
            this.searchParams.code = record.concept_code

            let _seach = this.searchParams;
            _seach.sort='stock_zhangdiefu';
            let res = await this.$store.dispatch('enterpriseLabStockBkDetailAction', { data: _seach })
            this.detail_list = [];
            this.detail_list = res.data.list
            this.liuruChart = res.data.liuru_chart
            this.dlLoading = false;
        },
        handleSort(e){
            this.searchData.bk_sort = e.target.value;
            // this.getDetail(this.record)
            this.clkzt(this.zt_name)
        },
        handleLineButChange(e){
            if(this.paramsData.search.line_type == e){
                this.paramsData.search.line_type = ''
            }else{
                this.paramsData.search.line_type = e
            }
            this.getList()
        },
        handleSzButChange(e){
            if(this.paramsData.search.sz_type == e){
                this.paramsData.search.sz_type = ''
            }else{
                this.paramsData.search.sz_type = e
            }
            this.getList()
        },
        handleButChange(e){
            if(this.paramsData.search.shsz == e){
                this.paramsData.search.shsz = ''
            }else{
                this.paramsData.search.shsz = e
            }
            this.getList()
        },
        async clkzt(stock_reason){
            this.zt_name = stock_reason;
            this.dVisible = true;
            this.dlLoading = true;
            let obj = {}
            let { searchData } = this
            if (searchData) {
                for (let k in searchData) {
                    obj[k] = searchData[k]
                }
            }
            obj['start_date'] = this.paramsData.start_date
            obj['end_date'] = this.paramsData.end_date
            obj['keyword']=stock_reason;
            this.searchParams.search = obj
            let _seach = this.searchParams;
            _seach.sort='stock_zhangdiefu';
            let res = await this.$store.dispatch('enterpriseLabStockBkDetailAction', { data: _seach })
            this.detail_list = [];
            this.detail_list = res.data.list
            this.liuruChart = res.data.liuru_chart
            this.dlLoading = false;
            //sthis.paramsData.search.stock_reason = stock_reason;
        },
        clkConceptIsAry(concept) {
            if (!concept) {
                // If concept is empty (All button), show all items
                this.filtered_list = this.list;
            } else {
                // Filter items by the selected concept locally
                this.filtered_list = this.list.filter(item => {
                    if (item.concept_is_ary && Array.isArray(item.concept_is_ary)) {
                        return item.concept_is_ary.includes(concept);
                    }
                    return false;
                });
            }
        },
        onFsChange(date, dateString) {
            this.paramsData.search.stock_date = dateString
            this.getPredictChart(this.stockCode);
        },
        clkFs(data){
            this.fsVisible = true;
            this.fs_list = data.sub_fs;
        },
        color(value){
          if(value < 0){
            return {color:'green'};
          }
          if(value==0){
            return '';
          }
          if(value > 0){
            return {color:'red'};
          }
        },
        formatNumber(value) {
          if(!value) return '0';
          let flag = '';
          if(value<0){
            value=Math.abs(value)
            flag = '-';
          }
          if (value >= 100000000) {
            return flag+(value / 100000000).toFixed(2) + ' 亿';
          } else if (value >= 10000) {
            return flag+(value / 10000).toFixed(2) + ' 万';
          } else {
            return flag+value;
          }
        },
        async handleOk() {
            //window.open("https://quote.eastmoney.com/"+this.stockCode+".html");
           this.getPredictChart(this.stockCode)  
        },
        clktime(stock_code,stock_detail){
          this.kickVisible = true;
          this.stockCode = stock_code;
          this.stock_detail = stock_detail;
          this.paramsData.search.stock_date = '';
          //console.log(stock_code)
          this.getKickTree(stock_code)
        },
        clk(stock_code,stock_detail){
          this.stockCode = stock_code;
          this.stock_detail = stock_detail;
          //console.log(stock_detail);
        //   this.stock_detail.stock_name 
          this.paramsData.search.stock_date = '';
          //console.log(stock_code)
          this.getPredictChart(stock_code)
        },
        async getKickTree(stock_code) {
              this.kickLoading = true;
              let res = await this.$store.dispatch('enterpriseLabStockKickTreeAction', {data:{search:{stock_code:stock_code},'per-page': 50}})
              this.kick_list = res.items
              this.pageParams = res._meta
              this.kickLoading = false;
              
        },
        async getPredictChart(stock_code) {
              this.editVisible = true;
              this.loadingP = true;
              console.log(this.paramsData)
              let res = await this.$store.dispatch('enterpriseLabLiuruAction', {data:{search:{stock_name:stock_code,stock_date:this.paramsData.start_date},'type':'kick'}})
              this.predictChart = res.data.predict_chart
              this.predictLiuruChart = res.data.predict_liuru_chart
              this.pie = res.data.pie
              this.kick_his_list = res.data.kick_his_list
              this.rankPrice = res.data.rankPrice
              this.day_line = res.data.day_line
              this.predictMsg = res.data.fs_list
              this.stock_title =  this.stock_detail.n
              this.fs_list_chart = res.data.sub_fs_chart;
              this.kick_amount = res.data.kick_amount
              this.orderBookChart = res.data.order_book_chart
            //   this.predictMsg = res.data.short_msg
              this.liuruList = res.data.liuru_list
              this.loadingP = false
        },
        onCopy(){
                this.$message.success('已复制到剪切板!')
        },
        onError(){
            this.$message.error('操作失败!')
        },
        viewConcept(record){
            this.record = record
            this.concept = true;
            // this.searchData.bk_sort = record.bk_sort;
            this.drvisible = true;
            this.stock_detail = record;
        },
        view(record){
            this.concept = false;
            this.record = record
            // this.searchData.bk_sort = record.bk_sort;
            this.getDetail(record)
        },
        showDelModal(item) {
            let res = this.$store.dispatch('enterpriseFiscalDelAction',{data:{fisca_id:item.id}})
            this.getList();
        },
        showEditModal(item) {
            this.modalData = item
            this.editVisible = true
        },
        hideEditModal(type) {
            if (type === 1) {
                this.getList()
            }
            this.editVisible = false
        },
        async getList(add,sh) {
            this.loading = true
            let obj = this.paramsData;
            obj.search.add = add;
            obj.search.sh = sh;
            let res = await this.$store.dispatch('enterpriseLabStockBiliAction', {data:obj})
            this.list = res.items
            this.filtered_list = res.items
            this.bili_total = res.bili_count
            this.stk_count = res.stk_count
            this.anaysis = res.analysis
            this.kick_resason_list = res.kick_list
            this.main_list = res.main_list
            this.sort_kick_resason_list = res.sort_kick_list
            this.concept_short_list = res.concept_short_list
            this.yesterday_kick_resason_list = res.yesterday_kick_list
            this.bk_list = res.bk_list
            this.bk_two_list = res.bk_two_list
            
            // Extract unique concept_is_ary values from the list items
            const conceptIsArySet = new Set();
            if (res.items && Array.isArray(res.items)) {
                res.items.forEach(item => {
                    if (item.concept_is_ary && Array.isArray(item.concept_is_ary)) {
                        item.concept_is_ary.forEach(concept => {
                            conceptIsArySet.add(concept);
                        });
                    }
                });
            }
            this.concept_is_ary_list = Array.from(conceptIsArySet).map(concept => ({ concept_is_ary: concept }));
            
            this.loading = false
        },
        async getApp(val){
            await this.$store.dispatch('enterpriseFilterAppAction', {data:{app_name:val}})
            .then((res)=>{
                this.appList = res.data
            })
        },
        toScreen(){
            this.getList();
        },
        handleButDateChange(e){
            this.searchData.bk_date = e.target.value
            this.getDetail(this.record)
        },
        zuixincolor(value,target){
            if(Number(value) < Number(target)){
            return {color:'green'};
            }
            if(value==0){
            return '';
            }
            if(Number(value) > Number(target)){
            return {color:'red'};
            }
        },
        handleSearchApp(val){
            this.getApp(val)
        },
        // handleButChange(e){
        //     this.paramsData.search.stock_status = e.target.value
        //     this.getList()
        // },
        handleChange(pagination, filters, sorter){
            if(sorter.order){
                if(sorter.order === "ascend"){
                    this.paramsData['sort'] = `${sorter.field}`
                }else{
                    this.paramsData['sort'] = `-${sorter.field}`
                }
                }else{
                this.paramsData['sort'] = ''
                }
            this.getList()
        },
        handleChange2(pagination, filters, sorter){
            if(sorter.order){
                if(sorter.order === "ascend"){
                    this.searchParams['sort'] = `${sorter.column.key}`
                }else{
                    this.searchParams['sort'] = `-${sorter.column.key}`
                }
                }else{
                this.searchParams['sort'] = ''
            }
            this.getDetail(this.record)
        },
        // 将analysis数据转换为CSV格式
        convertToCSV(data) {
            if (!data || data.length === 0) {
                return '';
            }
            
            // 获取所有可能的键
            const allKeys = new Set();
            data.forEach(item => {
                Object.keys(item).forEach(key => allKeys.add(key));
            });
            
            const headers = Array.from(allKeys);
            
            // 创建CSV内容
            let csvContent = headers.join(',') + '\n';
            
            data.forEach(item => {
                const row = headers.map(header => {
                    const value = item[header] !== undefined ? item[header] : '';
                    // 处理包含逗号或引号的值
                    if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
                        return `"${value.replace(/"/g, '""')}"`;
                    }
                    return value;
                });
                csvContent += row.join(',') + '\n';
            });
            
            return csvContent;
        },
        // 下载分析数据为CSV文件
        downloadAnalysisData() {
            if (!this.anaysis || this.anaysis.length === 0) {
                this.$message.warning('没有可下载的分析数据');
                return;
            }
            
            const csvContent = this.convertToCSV(this.anaysis);
            if (!csvContent) {
                this.$message.error('数据转换失败');
                return;
            }
            
            // 创建Blob对象
            const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
            
            // 创建下载链接
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            
            // 生成文件名，包含当前日期
            const today = new Date();
            const dateStr = today.toISOString().slice(0, 10);
            link.setAttribute('download', `analysis_data_${dateStr}.csv`);
            
            // 触发点击事件
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            this.$message.success('分析数据已下载');
        },
        // 将record.shape数组转换为指定格式并复制到剪贴板
        copyShapeToClipboard(record) {
            try {
                // 添加调试信息
                console.log('copyShapeToClipboard called with record:', record);
                console.log('Record keys:', Object.keys(record));
                
                // 检查record中是否存在shape属性
                if (!record || !record.shape) {
                    this.$message.warning('记录中没有shape数据');
                    return;
                }
                
                // 创建临时文本区域元素
                const textArea = document.createElement('textarea');
                textArea.value = record.shape;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                textArea.style.top = '-999999px';
                document.body.appendChild(textArea);
                
                // 选择并复制文本
                textArea.focus();
                textArea.select();
                const successful = document.execCommand('copy');
                
                // 移除临时元素
                document.body.removeChild(textArea);
                
                if (successful) {
                    this.$message.success('shape数据已复制到剪贴板');
                } else {
                    this.$message.error('复制失败，请手动复制');
                }
            } catch (error) {
                console.error('复制shape数据时出错:', error);
                this.$message.error('复制失败: ' + error.message);
            }
        },
        // 根据rank值返回对应的CSS类名
        getRankClass(rank) {
            switch(rank) {
                case "1":
                    return 'rank-high';
                case "2":
                    return 'rank-medium';
                case "3":
                    return 'rank-low';
                default:
                    return '';
            }
        },
        // 检查shape数据中是否包含孕线信号
        getPregnantLineSignal(record) {
            try {
                // 检查record中是否存在shape属性
                if (!record || !record.shape) {
                    return null;
                }
                
                // 遍历shape数据，查找孕线信号
                for (const date in record.shape) {
                    const dayData = record.shape[date];
                    if (dayData && typeof dayData === 'object') {
                        // 检查是否包含孕线相关的信号
                        // 孕线信号通常包括CDLHARAMI、CDLHARAMICROSS等
                        const pregnantSignals = ['CDLHARAMI', 'CDLHARAMICROSS'];
                        
                        for (const signal of pregnantSignals) {
                            if (dayData[signal]) {
                                const value = dayData[signal];
                                return {
                                    text: `${value}`,
                                    color: value > 0 ? '#f5222d' : '#52c41a' // 正值为红色，负值为绿色
                                };
                            }
                        }
                    }
                }
                
                return null;
            } catch (error) {
                console.error('检查孕线信号时出错:', error);
                return null;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.cell-content {
  white-space: normal; /* 允许换行 */
  word-wrap: break-word; /* 长单词换行 */
}
.ant-modal-body .ant-row{
    margin: 10px 20px !important;
}

.table-container {
  overflow-x: auto; /* 启用水平滚动 */
  width: 100%;
  
  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    height: 8px; /* 水平滚动条高度 */
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
}

/* 确保表格在容器中正确显示 */
.ant-table {
  min-width: 100%;
  
  .ant-table-body {
    overflow-x: auto !important;
  }
}

/* Rank 样式 */
.rank-high {
  color: #f5222d;
  font-weight: bold;
  background-color: #fff1f0;
  padding: 2px 6px;
  border-radius: 4px;
}

.rank-medium {
  color: #fa8c16;
  font-weight: bold;
  background-color: #fff7e6;
  padding: 2px 6px;
  border-radius: 4px;
}

.rank-low {
  color: #52c41a;
  font-weight: bold;
  background-color: #f6ffed;
  padding: 2px 6px;
  border-radius: 4px;
}
</style>